<template>
  <div v-if="isLogin" id="header-omc-wrapper" @click="isMobile ? $router.push({ name: 'MyPage' }) : null">
    <div class="d-flex">
      <Roller class="header-omc" :text="totalToken[0]" is-number-format :transition="0.5" />
      <span>.</span>
      <Roller class="header-omc decimal" :text="totalToken[1]" :transition="0.5" />
    </div>
    <img class="symbol" :src="`${$s3}/img/common/omc.webp?${$ver}`" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Roller from 'vue-roller';

export default {
  components: {
    Roller,
  },
  computed: {
    ...mapState(['isLogin', 'isMobile', 'total_token', 'totalTokenZIndex']),
    totalToken() {
      const [f, s] = this.total_token.toString().split('.');

      return [f, s?.padEnd(2, '0') ?? '00'];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

#header-omc-wrapper {
  min-width: fit-content;
  display: grid;
  grid-template-areas: 'symbol omc';
  grid-template-columns: repeat(2, auto);
  gap: 0.25em;
  align-items: center;
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;

  @include tablet {
    font-size: 16px;
  }

  .d-flex {
    grid-area: omc;
  }
  .symbol {
    grid-area: symbol;
    width: 27px;

    @include tablet {
      width: 16px;
    }
  }
  .header-omc {
    min-width: fit-content;
    float: left;
    cursor: default;
    user-select: none;
    -webkit-user-drag: none;
    color: #fff;
    text-align: center;

    &.decimal {
      margin-top: 2.5px;
      font-size: 26px;

      @include tablet {
        margin-top: 0.7px;
        font-size: 13.5px;
      }
    }
  }
}
</style>
